module.exports = __webpack_public_path__ + "static/media/star-runner-screenshot-3.a3aaab00.jpg";